(function () {
    let currentSorting = 'date-descending';

    function registerEvents() {
        const sortingFilterElements = document.querySelectorAll('.blog-sorting-option');

        if (sortingFilterElements) {
            sortingFilterElements.forEach(sortingFilterElement => {
                sortingFilterElement.addEventListener('click', onSortingFilterOptionClick);
            })
        }
    }

    function onSortingFilterOptionClick() {
        const sortingFilterElements = document.querySelectorAll('.blog-sorting-option')
        const sortingType = this.getAttribute('data-value');

        sortingFilterElements.forEach(sortingFilterElement => {
            sortingFilterElement.innerHTML = sortingFilterElement.innerHTML.replace('<i class="fa fa-solid fa-check"></i>', '');
        });

        currentSorting = sortingType;

        this.innerHTML += "&nbsp;<i class='fa fa-solid fa-check'></i>";

        sortBlogByCurrentSorting()
    }

    function sortBlogByCurrentSorting() {
        const blogArticleContainerElement = document.querySelector('.blog--inner');
        const blogArticles = loadBlogArticles();

        let sortedBlog = Array.from(blogArticles),
            sortedBlogContent = '';

        switch (currentSorting) {
            case "date-ascending":
                sortedBlog.sort((a, b) => {
                    return new Date(b.getAttribute('data-blog-article-published-date')) - new Date(a.getAttribute('data-blog-article-published-date'));
                });
                break;
            case "date-descending":
                sortedBlog.sort((a, b) => {
                    return new Date(a.getAttribute('data-blog-article-published-date')) - new Date(b.getAttribute('data-blog-article-published-date'));
                });
                break;
            case "title-descending":
                sortedBlog.sort((a, b) => {
                    return a.getAttribute('data-blog-article-title') < b.getAttribute('data-blog-article-title') ? -1 : 1;
                });
                break;
            case "title-ascending":
                sortedBlog.sort((a, b) => {
                    return a.getAttribute('data-blog-article-title') > b.getAttribute('data-blog-article-title') ? -1 : 1;
                });
                break;
        }

        sortedBlog.forEach(blogArticle => {
            sortedBlogContent += blogArticle.closest('.article--excerpt-wrapper').outerHTML;
        });

        blogArticleContainerElement.innerHTML = sortedBlogContent;
    }

    function loadBlogArticles() {
        return document.querySelectorAll('[data-filterable-blog-article]');
    }

    document.addEventListener('DOMContentLoaded', () => {
        registerEvents();
    });
})();

